import store from '../../../store';
import selectors from '../selectors';

const getMenu = () => {
  const state = store.getState();

  return selectors.getMenu(state);
};

export default getMenu;
